import { render, staticRenderFns } from "./ManageSenserList.vue?vue&type=template&id=b2d47de4&"
import script from "./ManageSenserList.vue?vue&type=script&lang=js&"
export * from "./ManageSenserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports